// These mirror the caps lukita enforces in Project::CaseFact.
export const MAX_FACT_LENGTH = 300
export const MAX_FACTS_PER_CASE = 40
